import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import { compose } from 'react-apollo';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
// legacy imports
import ProgressChecks from './ProgressChecks';
import { useAssessmentProgressComponent } from 'chameleon/ui-stack/ui/units/subunit-content/ppc';

const getUnitResources = (unitsState, unitId) =>
  (unitsState[`unit-${unitId}`] || {}).resources || {};

const TeacherProgressChecks = (props) => {
  const {
    resources = [],
    subjectData,
    assignments = [],
    unitId,
    unitNumber,
    unitTitle,
    userData,
    router,
    showRightContent = true,
    unitsState,
    params: { subject },
    type: subunitType,
    unitDisplayName,
    assessmentDataCache,
    disablePpcAutoAssignFlag,
    useClassroomResourceAddress,
  } = props;
  const subjectId = typeof subjectData === 'object' ? subjectData.id : subject;
  const { areAssignmentStatusesLoaded } = unitsState;
  const [isLoading, setIsLoading] = useState(true);
  const [resourceStatuses, setResourceStatuses] = useState({});

  const { isAdmin, isCoordinator, isStudent, isTeacher } = userData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;

  const { getProgressCheckResourceAction } = useAssessmentProgressComponent({
    router,
    subjectData,
    subjectId,
    subunitType,
    disablePpcAutoAssignFlag,
    resourceStatuses,
    unitId,
    unitNumber,
    unitTitle,
    isAdminOrCoordinator,
    isTeacher,
    isStudent,
    assessmentDataCache,
    assignments,
  });

  useEffect(() => {
    if (areAssignmentStatusesLoaded) {
      setResourceStatuses(getUnitResources(unitsState, unitId));
      setIsLoading(false);
    }
  }, [areAssignmentStatusesLoaded]);

  useEffect(() => {
    if (areAssignmentStatusesLoaded) {
      setResourceStatuses(getUnitResources(unitsState, unitId));
    }
  }, [unitsState]);

  const onSetPreviewUrl = (assessmentId) => {
    const {
      location: { search },
    } = router;
    const returnPath = `/${subjectId}/home${search}`;
    return `/${subjectId}/assignments?quizId=${assessmentId}&returnPath=${returnPath}`;
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const onResourceClicked = (resource, url) => router.push(url);

  return (
    <ProgressChecks
      resources={resources}
      getResourceActions={getProgressCheckResourceAction}
      getAssignmentUrl={onSetPreviewUrl}
      showRightContent={showRightContent}
      onResourceClicked={onResourceClicked}
      unitDisplayName={unitDisplayName}
      unitNumber={unitNumber}
      subunitType={subunitType}
      useClassroomResourceAddress={useClassroomResourceAddress}
    />
  );
};

TeacherProgressChecks.displayName = 'TeacherProgressChecks';

const mapStateToProps = ({
  subject,
  userData,
  assessmentDataCache,
  featureFlag,
}) => {
  return {
    subjectData: subject.data,
    userData,
    assessmentDataCache,
    disablePpcAutoAssignFlag: featureFlag.disable_ppc_auto_assign,
  };
};
export default compose(
  connectLean({
    scope: 'units',
    mapState: (state) => ({
      unitsState: state,
    }),
  }),
  connect(mapStateToProps),
)(withRouter(TeacherProgressChecks));
